// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * WE2 P4-02: Drawing toolbar styles.
 * .vnsc- prefix for widget namespace.
 */

.vnsc-drawing-toolbar {
	position: relative;
	height: 100%;
	width: 42px;
	min-width: 42px;
	flex-shrink: 0;
	z-index: 40;
	background: var(--vnsc-bg-secondary);
	border-right: 1px solid var(--vnsc-border-subtle, var(--vnsc-border));
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 6px 0;
	gap: 6px;
	overflow-x: hidden;
	overflow-y: auto;
	scrollbar-width: none;
	transition: width 0.2s ease, padding 0.2s ease, border-right-width 0.2s ease;
}

/* P5/D-UI-05: doubled specificity instead of !important — wins over the base
   rule below by specificity, collapses fully via the --collapsed modifier. */
.vnsc-drawing-toolbar.vnsc-drawing-toolbar--collapsed {
	width: 0;
	min-width: 0;
	padding: 0;
	border-right: none;
	overflow: hidden;
}

.vnsc-drawing-toolbar__expand-btn {
	transition: background-color var(--vnsc-transition-fast), color var(--vnsc-transition-fast), transform var(--vnsc-transition-fast);
}

.vnsc-drawing-toolbar__expand-btn:hover {
	background-color: var(--vnsc-bg-tertiary, #f1f5f9) !important;
	color: var(--vnsc-text-primary) !important;
	transform: scale(1.05);
}


.vnsc-drawing-toolbar::-webkit-scrollbar {
	display: none;
}

.vnsc-drawing-toolbar__group {
	display: flex;
	flex-direction: column;
	gap: 1px;
	margin-bottom: 4px;
}

.vnsc-drawing-toolbar__group:not(:last-child) {
	border-bottom: 1px solid var(--vnsc-border);
	padding-bottom: 4px;
}

.vnsc-drawing-toolbar__btn {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	border: none;
	border-radius: var(--vnsc-radius-md, 4px);
	background: transparent;
	color: var(--vnsc-text-secondary);
	cursor: pointer;
	font-size: 14px;
	font-weight: 600;
	transition: background var(--vnsc-transition-fast), color var(--vnsc-transition-fast);
}

.vnsc-drawing-toolbar__btn:hover {
	background: rgba(41, 98, 255, 0.08);
	color: var(--vnsc-text-primary);
}

.vnsc-drawing-toolbar__btn--active {
	background: var(--vnsc-accent-bg, rgba(41, 98, 255, 0.12));
	color: var(--vnsc-accent);
}

.vnsc-drawing-toolbar__btn--active:hover {
	background: var(--vnsc-accent-bg, rgba(41, 98, 255, 0.18));
}

.vnsc-drawing-toolbar__magnet {
	width: 32px;
	height: 32px;
	border: none;
	border-radius: var(--vnsc-radius-md, 4px);
	background: transparent;
	color: var(--vnsc-text-secondary);
	cursor: pointer;
	font-size: 12px;
	font-weight: 700;
	transition: background var(--vnsc-transition-fast), color var(--vnsc-transition-fast);
}

.vnsc-drawing-toolbar__magnet:hover {
	background: rgba(41, 98, 255, 0.08);
}

/* ── Upgraded Grouped Flyout Styles ── */

.vnsc-tools-group-container {
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.vnsc-tool-btn--group {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1px;
}

.vnsc-tools-chevron {
	font-size: 7px;
	line-height: 1;
	opacity: 0.6;
	pointer-events: none;
}

.vnsc-tools-flyout {
	position: fixed;
	z-index: var(--vnsc-z-maximum);
	background: var(--vnsc-bg-primary, #0a0e14);
	border: 1px solid var(--vnsc-border, #2a2a2a);
	border-radius: var(--vnsc-radius-md, 6px);
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
	display: flex;
	flex-direction: column;
	width: 220px;
	overflow: hidden;
}

.vnsc-drawing-toolbar__btn:hover .vnsc-tool-fav-star {
	opacity: 0.5 !important;
}

.vnsc-tool-fav-star:hover {
	opacity: 1 !important;
	color: var(--vnsc-accent, #2962ff) !important;
}

.vnsc-tools-flyout input::placeholder {
	color: var(--vnsc-text-secondary, #a0a0a0);
	opacity: 0.6;
}

.vnsc-tools-flyout input:focus {
	border-color: var(--vnsc-accent, #2962ff) !important;
}

/* ── Auto-hide Drawing Toolbar ── */
/* P5/D-UI-05: single source of truth — plain specificity (shell selectors beat
   the base rules below); no !important needed since the component no longer
   sets conflicting inline layout styles (see DrawingToolbar.tsx).
   Off-screen state is also removed from keyboard/AT order via delayed
   visibility (fixes the focus trap); :focus-within keeps it open while
   tabbing through its controls. */

.vnsc-drawing-toolbar-shell {
	position: absolute;
	left: 0;
	top: 0;
	bottom: 0;
	width: 10px;
	pointer-events: none;
	/* Above pane overlay wraps (z-40, later in DOM) so the rail strip stays
	   hoverable across the full height — incl. the Vol pane header band where
	   the indicator chip + splitter would otherwise cover it and force the
	   toolbar shut. Below flyout portals. */
	z-index: 60;
	transition: width 0.2s ease;
}

.vnsc-drawing-toolbar-shell:hover,
.vnsc-drawing-toolbar-shell:has(input:focus) {
	width: 42px;
	pointer-events: auto;
}

.vnsc-drawing-toolbar {
	position: absolute;
	left: -42px;
	top: 0;
	bottom: 0;
	width: 42px;
	min-width: 42px;
	pointer-events: auto;
	z-index: 3;
	transition: left 0.2s ease, box-shadow 0.2s ease, border-right-color 0.2s ease, visibility 0s linear 0.2s;
	border-right: 1px solid transparent;
	box-shadow: none;
	visibility: hidden;
}

.vnsc-drawing-toolbar-shell:hover .vnsc-drawing-toolbar,
.vnsc-drawing-toolbar:hover,
.vnsc-drawing-toolbar-shell:has(input:focus) .vnsc-drawing-toolbar,
.vnsc-drawing-toolbar:has(input:focus),
.vnsc-drawing-toolbar-shell:focus-within .vnsc-drawing-toolbar {
	left: 0;
	box-shadow: 2px 0 12px rgba(0, 0, 0, 0.15);
	border-right-color: var(--vnsc-border-subtle, var(--vnsc-border));
	visibility: visible;
	transition: left 0.2s ease, box-shadow 0.2s ease, border-right-color 0.2s ease;
}

.vnsc-drawing-toolbar-handle {
	display: flex;
	position: absolute;
	top: 50%;
	left: 0;
	width: 10px;
	height: 44px;
	transform: translateY(-50%);
	align-items: center;
	justify-content: center;
	border-radius: 0 var(--vnsc-radius-xl, 8px) var(--vnsc-radius-xl, 8px) 0;
	border: 1px solid var(--vnsc-border);
	border-left: none;
	background: linear-gradient(
		180deg,
		color-mix(in srgb, var(--vnsc-bg-primary) 92%, var(--vnsc-accent) 8%),
		color-mix(in srgb, var(--vnsc-bg-secondary) 88%, var(--vnsc-accent) 12%)
	);
	box-shadow: 6px 10px 22px rgba(15, 23, 42, 0.16);
	pointer-events: auto;
	opacity: 1;
	z-index: 2;
	transition: opacity 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;
}

.vnsc-drawing-toolbar-handle::before {
	content: "";
	width: 3px;
	height: 3px;
	border-radius: 999px;
	background: var(--vnsc-text-secondary);
	box-shadow:
		0 -6px 0 var(--vnsc-text-secondary),
		0 6px 0 var(--vnsc-text-secondary);
}

/* Docked toolbar mode (TASK-03) */
.vnsc-drawing-toolbar-shell--docked {
	width: 44px;
	pointer-events: auto;
}

.vnsc-drawing-toolbar-shell--docked .vnsc-drawing-toolbar {
	left: 0;
	visibility: visible;
	border-right: 1px solid var(--vnsc-border-subtle, var(--vnsc-border));
	box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
}

.vnsc-drawing-toolbar-shell--docked .vnsc-drawing-toolbar-handle {
	display: none;
}

/* Adjust OHLC header padding dynamically to prevent occlusion by the handle/toolbar */
.vnsc-ohlc-header {
	padding-left: 22px !important;
	transition: padding-left 0.2s ease !important;
}
.vnsc-container:has(.vnsc-drawing-toolbar-shell:hover) .vnsc-ohlc-header,
.vnsc-container:has(.vnsc-drawing-toolbar-shell:focus-within) .vnsc-ohlc-header {
	padding-left: 54px !important;
}
.vnsc-container:has(.vnsc-drawing-toolbar-shell--collapsed) .vnsc-ohlc-header {
	padding-left: 12px !important;
}

/* P5: doubled specificity instead of !important (rules sit after the hover
   rules above, so a collapsed shell stays shut on hover). */
.vnsc-drawing-toolbar-shell.vnsc-drawing-toolbar-shell--collapsed {
	width: 0;
	pointer-events: none;
}

.vnsc-drawing-toolbar-shell.vnsc-drawing-toolbar-shell--collapsed .vnsc-drawing-toolbar-handle {
	display: none;
}

@media (max-width: 768px) {
	.vnsc-drawing-toolbar {
		width: 48px !important;
		min-width: 48px !important;
		gap: 6px !important;
		padding: 6px 0 !important;
	}

	.vnsc-drawing-toolbar__btn {
		width: 40px !important;
		height: 40px !important;
		font-size: 16px !important;
		border-radius: 6px !important;
	}

	.vnsc-drawing-toolbar__expand-btn {
		width: 44px !important;
		height: 44px !important;
		left: 12px !important;
		bottom: 20px !important;
		font-size: 18px !important;
		border-radius: 8px !important;
		box-shadow: 0 4px 14px rgba(0, 0, 0, 0.4) !important;
	}
}

/* ── Floating Favorites Bar & Star Toggle (TradingView Parity) ── */

.vnsc-drawing-toolbar__btn--star-active {
	color: #f59e0b !important;
	background: rgba(245, 158, 11, 0.12) !important;
}

.vnsc-drawing-toolbar__btn--star-active:hover {
	background: rgba(245, 158, 11, 0.22) !important;
}

.vnsc-floating-favorites-bar {
	position: fixed;
	z-index: var(--vnsc-z-popup, 20);
	display: inline-flex;
	align-items: center;
	gap: 3px;
	background: var(--vnsc-bg-primary, #0a0e14);
	border: 1px solid var(--vnsc-border, #2a2a2a);
	border-radius: var(--vnsc-radius-md, 8px);
	padding: 4px 6px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.32);
	user-select: none;
	white-space: nowrap;
}

.vnsc-floating-favorites-grip {
	cursor: grab;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 14px;
	height: 28px;
	color: var(--vnsc-text-secondary, #a0a0a0);
	opacity: 0.7;
	transition: opacity var(--vnsc-transition-fast, 0.15s), color var(--vnsc-transition-fast, 0.15s);
	user-select: none;
	touch-action: none;
	font-size: 12px;
	letter-spacing: 1px;
}

.vnsc-floating-favorites-grip:hover {
	opacity: 1;
	color: var(--vnsc-text-primary, #ffffff);
}

.vnsc-floating-favorites-grip:active {
	cursor: grabbing;
}

.vnsc-floating-favorites-divider {
	width: 1px;
	height: 18px;
	background: var(--vnsc-border-subtle, #2a2a2a);
	margin: 0 3px;
	flex-shrink: 0;
}

.vnsc-floating-favorites-close {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	border: none;
	background: transparent;
	border-radius: 4px;
	color: var(--vnsc-text-secondary, #a0a0a0);
	cursor: pointer;
	transition: background var(--vnsc-transition-fast, 0.15s), color var(--vnsc-transition-fast, 0.15s);
	font-size: 13px;
	line-height: 1;
	padding: 0;
}

.vnsc-floating-favorites-close:hover {
	background: rgba(239, 68, 68, 0.15);
	color: #ef4444;
}

`, "",{"version":3,"sources":["webpack://./src/widget/styles/toolbar.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,eAAe;CACf,cAAc;CACd,WAAW;CACX,oCAAoC;CACpC,qEAAqE;CACrE,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,cAAc;CACd,QAAQ;CACR,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB;CACrB,4EAA4E;AAC7E;;AAEA;6EAC6E;AAC7E;CACC,QAAQ;CACR,YAAY;CACZ,UAAU;CACV,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,kIAAkI;AACnI;;AAEA;CACC,6DAA6D;CAC7D,0CAA0C;CAC1C,sBAAsB;AACvB;;;AAGA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;CACR,kBAAkB;AACnB;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,yCAAyC;CACzC,uBAAuB;CACvB,iCAAiC;CACjC,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,qFAAqF;AACtF;;AAEA;CACC,mCAAmC;CACnC,+BAA+B;AAChC;;AAEA;CACC,0DAA0D;CAC1D,yBAAyB;AAC1B;;AAEA;CACC,0DAA0D;AAC3D;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,yCAAyC;CACzC,uBAAuB;CACvB,iCAAiC;CACjC,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,qFAAqF;AACtF;;AAEA;CACC,mCAAmC;AACpC;;AAEA,yCAAyC;;AAEzC;CACC,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,cAAc;CACd,cAAc;CACd,YAAY;CACZ,oBAAoB;AACrB;;AAEA;CACC,eAAe;CACf,8BAA8B;CAC9B,2CAA2C;CAC3C,6CAA6C;CAC7C,yCAAyC;CACzC,yCAAyC;CACzC,aAAa;CACb,sBAAsB;CACtB,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,qBAAqB;CACrB,6CAA6C;AAC9C;;AAEA;CACC,0CAA0C;CAC1C,YAAY;AACb;;AAEA;CACC,oDAAoD;AACrD;;AAEA,oCAAoC;AACpC;;;;;kCAKkC;;AAElC;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,SAAS;CACT,WAAW;CACX,oBAAoB;CACpB;;;yCAGwC;CACxC,WAAW;CACX,2BAA2B;AAC5B;;AAEA;;CAEC,WAAW;CACX,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,MAAM;CACN,SAAS;CACT,WAAW;CACX,eAAe;CACf,oBAAoB;CACpB,UAAU;CACV,yGAAyG;CACzG,mCAAmC;CACnC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;;;;;CAKC,OAAO;CACP,0CAA0C;CAC1C,iEAAiE;CACjE,mBAAmB;CACnB,8EAA8E;AAC/E;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,QAAQ;CACR,OAAO;CACP,WAAW;CACX,YAAY;CACZ,2BAA2B;CAC3B,mBAAmB;CACnB,uBAAuB;CACvB,wEAAwE;CACxE,oCAAoC;CACpC,iBAAiB;CACjB;;;;EAIC;CACD,gDAAgD;CAChD,oBAAoB;CACpB,UAAU;CACV,UAAU;CACV,2EAA2E;AAC5E;;AAEA;CACC,WAAW;CACX,UAAU;CACV,WAAW;CACX,oBAAoB;CACpB,sCAAsC;CACtC;;oCAEmC;AACpC;;AAEA,kCAAkC;AAClC;CACC,WAAW;CACX,oBAAoB;AACrB;;AAEA;CACC,OAAO;CACP,mBAAmB;CACnB,qEAAqE;CACrE,wCAAwC;AACzC;;AAEA;CACC,aAAa;AACd;;AAEA,sFAAsF;AACtF;CACC,6BAA6B;CAC7B,6CAA6C;AAC9C;AACA;;CAEC,6BAA6B;AAC9B;AACA;CACC,6BAA6B;AAC9B;;AAEA;4DAC4D;AAC5D;CACC,QAAQ;CACR,oBAAoB;AACrB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC;EACC,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;CAC1B;;CAEA;EACC,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;CAC9B;;CAEA;EACC,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,oDAAoD;CACrD;AACD;;AAEA,oEAAoE;;AAEpE;CACC,yBAAyB;CACzB,+CAA+C;AAChD;;AAEA;CACC,+CAA+C;AAChD;;AAEA;CACC,eAAe;CACf,gCAAgC;CAChC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,2CAA2C;CAC3C,6CAA6C;CAC7C,yCAAyC;CACzC,gBAAgB;CAChB,0CAA0C;CAC1C,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;CACX,YAAY;CACZ,0CAA0C;CAC1C,YAAY;CACZ,gGAAgG;CAChG,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,wCAAwC;AACzC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,8CAA8C;CAC9C,aAAa;CACb,cAAc;AACf;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,uBAAuB;CACvB,kBAAkB;CAClB,0CAA0C;CAC1C,eAAe;CACf,mGAAmG;CACnG,eAAe;CACf,cAAc;CACd,UAAU;AACX;;AAEA;CACC,mCAAmC;CACnC,cAAc;AACf","sourcesContent":["/**\r\n * WE2 P4-02: Drawing toolbar styles.\r\n * .vnsc- prefix for widget namespace.\r\n */\r\n\r\n.vnsc-drawing-toolbar {\r\n\tposition: relative;\r\n\theight: 100%;\r\n\twidth: 42px;\r\n\tmin-width: 42px;\r\n\tflex-shrink: 0;\r\n\tz-index: 40;\r\n\tbackground: var(--vnsc-bg-secondary);\r\n\tborder-right: 1px solid var(--vnsc-border-subtle, var(--vnsc-border));\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\talign-items: center;\r\n\tpadding: 6px 0;\r\n\tgap: 6px;\r\n\toverflow-x: hidden;\r\n\toverflow-y: auto;\r\n\tscrollbar-width: none;\r\n\ttransition: width 0.2s ease, padding 0.2s ease, border-right-width 0.2s ease;\r\n}\r\n\r\n/* P5/D-UI-05: doubled specificity instead of !important — wins over the base\r\n   rule below by specificity, collapses fully via the --collapsed modifier. */\r\n.vnsc-drawing-toolbar.vnsc-drawing-toolbar--collapsed {\r\n\twidth: 0;\r\n\tmin-width: 0;\r\n\tpadding: 0;\r\n\tborder-right: none;\r\n\toverflow: hidden;\r\n}\r\n\r\n.vnsc-drawing-toolbar__expand-btn {\r\n\ttransition: background-color var(--vnsc-transition-fast), color var(--vnsc-transition-fast), transform var(--vnsc-transition-fast);\r\n}\r\n\r\n.vnsc-drawing-toolbar__expand-btn:hover {\r\n\tbackground-color: var(--vnsc-bg-tertiary, #f1f5f9) !important;\r\n\tcolor: var(--vnsc-text-primary) !important;\r\n\ttransform: scale(1.05);\r\n}\r\n\r\n\r\n.vnsc-drawing-toolbar::-webkit-scrollbar {\r\n\tdisplay: none;\r\n}\r\n\r\n.vnsc-drawing-toolbar__group {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 1px;\r\n\tmargin-bottom: 4px;\r\n}\r\n\r\n.vnsc-drawing-toolbar__group:not(:last-child) {\r\n\tborder-bottom: 1px solid var(--vnsc-border);\r\n\tpadding-bottom: 4px;\r\n}\r\n\r\n.vnsc-drawing-toolbar__btn {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\twidth: 32px;\r\n\theight: 32px;\r\n\tborder: none;\r\n\tborder-radius: var(--vnsc-radius-md, 4px);\r\n\tbackground: transparent;\r\n\tcolor: var(--vnsc-text-secondary);\r\n\tcursor: pointer;\r\n\tfont-size: 14px;\r\n\tfont-weight: 600;\r\n\ttransition: background var(--vnsc-transition-fast), color var(--vnsc-transition-fast);\r\n}\r\n\r\n.vnsc-drawing-toolbar__btn:hover {\r\n\tbackground: rgba(41, 98, 255, 0.08);\r\n\tcolor: var(--vnsc-text-primary);\r\n}\r\n\r\n.vnsc-drawing-toolbar__btn--active {\r\n\tbackground: var(--vnsc-accent-bg, rgba(41, 98, 255, 0.12));\r\n\tcolor: var(--vnsc-accent);\r\n}\r\n\r\n.vnsc-drawing-toolbar__btn--active:hover {\r\n\tbackground: var(--vnsc-accent-bg, rgba(41, 98, 255, 0.18));\r\n}\r\n\r\n.vnsc-drawing-toolbar__magnet {\r\n\twidth: 32px;\r\n\theight: 32px;\r\n\tborder: none;\r\n\tborder-radius: var(--vnsc-radius-md, 4px);\r\n\tbackground: transparent;\r\n\tcolor: var(--vnsc-text-secondary);\r\n\tcursor: pointer;\r\n\tfont-size: 12px;\r\n\tfont-weight: 700;\r\n\ttransition: background var(--vnsc-transition-fast), color var(--vnsc-transition-fast);\r\n}\r\n\r\n.vnsc-drawing-toolbar__magnet:hover {\r\n\tbackground: rgba(41, 98, 255, 0.08);\r\n}\r\n\r\n/* ── Upgraded Grouped Flyout Styles ── */\r\n\r\n.vnsc-tools-group-container {\r\n\tposition: relative;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\talign-items: center;\r\n}\r\n\r\n.vnsc-tool-btn--group {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\talign-items: center;\r\n\tgap: 1px;\r\n}\r\n\r\n.vnsc-tools-chevron {\r\n\tfont-size: 7px;\r\n\tline-height: 1;\r\n\topacity: 0.6;\r\n\tpointer-events: none;\r\n}\r\n\r\n.vnsc-tools-flyout {\r\n\tposition: fixed;\r\n\tz-index: var(--vnsc-z-maximum);\r\n\tbackground: var(--vnsc-bg-primary, #0a0e14);\r\n\tborder: 1px solid var(--vnsc-border, #2a2a2a);\r\n\tborder-radius: var(--vnsc-radius-md, 6px);\r\n\tbox-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\twidth: 220px;\r\n\toverflow: hidden;\r\n}\r\n\r\n.vnsc-drawing-toolbar__btn:hover .vnsc-tool-fav-star {\r\n\topacity: 0.5 !important;\r\n}\r\n\r\n.vnsc-tool-fav-star:hover {\r\n\topacity: 1 !important;\r\n\tcolor: var(--vnsc-accent, #2962ff) !important;\r\n}\r\n\r\n.vnsc-tools-flyout input::placeholder {\r\n\tcolor: var(--vnsc-text-secondary, #a0a0a0);\r\n\topacity: 0.6;\r\n}\r\n\r\n.vnsc-tools-flyout input:focus {\r\n\tborder-color: var(--vnsc-accent, #2962ff) !important;\r\n}\r\n\r\n/* ── Auto-hide Drawing Toolbar ── */\r\n/* P5/D-UI-05: single source of truth — plain specificity (shell selectors beat\r\n   the base rules below); no !important needed since the component no longer\r\n   sets conflicting inline layout styles (see DrawingToolbar.tsx).\r\n   Off-screen state is also removed from keyboard/AT order via delayed\r\n   visibility (fixes the focus trap); :focus-within keeps it open while\r\n   tabbing through its controls. */\r\n\r\n.vnsc-drawing-toolbar-shell {\r\n\tposition: absolute;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\twidth: 10px;\r\n\tpointer-events: none;\r\n\t/* Above pane overlay wraps (z-40, later in DOM) so the rail strip stays\r\n\t   hoverable across the full height — incl. the Vol pane header band where\r\n\t   the indicator chip + splitter would otherwise cover it and force the\r\n\t   toolbar shut. Below flyout portals. */\r\n\tz-index: 60;\r\n\ttransition: width 0.2s ease;\r\n}\r\n\r\n.vnsc-drawing-toolbar-shell:hover,\r\n.vnsc-drawing-toolbar-shell:has(input:focus) {\r\n\twidth: 42px;\r\n\tpointer-events: auto;\r\n}\r\n\r\n.vnsc-drawing-toolbar {\r\n\tposition: absolute;\r\n\tleft: -42px;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\twidth: 42px;\r\n\tmin-width: 42px;\r\n\tpointer-events: auto;\r\n\tz-index: 3;\r\n\ttransition: left 0.2s ease, box-shadow 0.2s ease, border-right-color 0.2s ease, visibility 0s linear 0.2s;\r\n\tborder-right: 1px solid transparent;\r\n\tbox-shadow: none;\r\n\tvisibility: hidden;\r\n}\r\n\r\n.vnsc-drawing-toolbar-shell:hover .vnsc-drawing-toolbar,\r\n.vnsc-drawing-toolbar:hover,\r\n.vnsc-drawing-toolbar-shell:has(input:focus) .vnsc-drawing-toolbar,\r\n.vnsc-drawing-toolbar:has(input:focus),\r\n.vnsc-drawing-toolbar-shell:focus-within .vnsc-drawing-toolbar {\r\n\tleft: 0;\r\n\tbox-shadow: 2px 0 12px rgba(0, 0, 0, 0.15);\r\n\tborder-right-color: var(--vnsc-border-subtle, var(--vnsc-border));\r\n\tvisibility: visible;\r\n\ttransition: left 0.2s ease, box-shadow 0.2s ease, border-right-color 0.2s ease;\r\n}\r\n\r\n.vnsc-drawing-toolbar-handle {\r\n\tdisplay: flex;\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 0;\r\n\twidth: 10px;\r\n\theight: 44px;\r\n\ttransform: translateY(-50%);\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tborder-radius: 0 var(--vnsc-radius-xl, 8px) var(--vnsc-radius-xl, 8px) 0;\r\n\tborder: 1px solid var(--vnsc-border);\r\n\tborder-left: none;\r\n\tbackground: linear-gradient(\r\n\t\t180deg,\r\n\t\tcolor-mix(in srgb, var(--vnsc-bg-primary) 92%, var(--vnsc-accent) 8%),\r\n\t\tcolor-mix(in srgb, var(--vnsc-bg-secondary) 88%, var(--vnsc-accent) 12%)\r\n\t);\r\n\tbox-shadow: 6px 10px 22px rgba(15, 23, 42, 0.16);\r\n\tpointer-events: auto;\r\n\topacity: 1;\r\n\tz-index: 2;\r\n\ttransition: opacity 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;\r\n}\r\n\r\n.vnsc-drawing-toolbar-handle::before {\r\n\tcontent: \"\";\r\n\twidth: 3px;\r\n\theight: 3px;\r\n\tborder-radius: 999px;\r\n\tbackground: var(--vnsc-text-secondary);\r\n\tbox-shadow:\r\n\t\t0 -6px 0 var(--vnsc-text-secondary),\r\n\t\t0 6px 0 var(--vnsc-text-secondary);\r\n}\r\n\r\n/* Docked toolbar mode (TASK-03) */\r\n.vnsc-drawing-toolbar-shell--docked {\r\n\twidth: 44px;\r\n\tpointer-events: auto;\r\n}\r\n\r\n.vnsc-drawing-toolbar-shell--docked .vnsc-drawing-toolbar {\r\n\tleft: 0;\r\n\tvisibility: visible;\r\n\tborder-right: 1px solid var(--vnsc-border-subtle, var(--vnsc-border));\r\n\tbox-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.vnsc-drawing-toolbar-shell--docked .vnsc-drawing-toolbar-handle {\r\n\tdisplay: none;\r\n}\r\n\r\n/* Adjust OHLC header padding dynamically to prevent occlusion by the handle/toolbar */\r\n.vnsc-ohlc-header {\r\n\tpadding-left: 22px !important;\r\n\ttransition: padding-left 0.2s ease !important;\r\n}\r\n.vnsc-container:has(.vnsc-drawing-toolbar-shell:hover) .vnsc-ohlc-header,\r\n.vnsc-container:has(.vnsc-drawing-toolbar-shell:focus-within) .vnsc-ohlc-header {\r\n\tpadding-left: 54px !important;\r\n}\r\n.vnsc-container:has(.vnsc-drawing-toolbar-shell--collapsed) .vnsc-ohlc-header {\r\n\tpadding-left: 12px !important;\r\n}\r\n\r\n/* P5: doubled specificity instead of !important (rules sit after the hover\r\n   rules above, so a collapsed shell stays shut on hover). */\r\n.vnsc-drawing-toolbar-shell.vnsc-drawing-toolbar-shell--collapsed {\r\n\twidth: 0;\r\n\tpointer-events: none;\r\n}\r\n\r\n.vnsc-drawing-toolbar-shell.vnsc-drawing-toolbar-shell--collapsed .vnsc-drawing-toolbar-handle {\r\n\tdisplay: none;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n\t.vnsc-drawing-toolbar {\r\n\t\twidth: 48px !important;\r\n\t\tmin-width: 48px !important;\r\n\t\tgap: 6px !important;\r\n\t\tpadding: 6px 0 !important;\r\n\t}\r\n\r\n\t.vnsc-drawing-toolbar__btn {\r\n\t\twidth: 40px !important;\r\n\t\theight: 40px !important;\r\n\t\tfont-size: 16px !important;\r\n\t\tborder-radius: 6px !important;\r\n\t}\r\n\r\n\t.vnsc-drawing-toolbar__expand-btn {\r\n\t\twidth: 44px !important;\r\n\t\theight: 44px !important;\r\n\t\tleft: 12px !important;\r\n\t\tbottom: 20px !important;\r\n\t\tfont-size: 18px !important;\r\n\t\tborder-radius: 8px !important;\r\n\t\tbox-shadow: 0 4px 14px rgba(0, 0, 0, 0.4) !important;\r\n\t}\r\n}\r\n\r\n/* ── Floating Favorites Bar & Star Toggle (TradingView Parity) ── */\r\n\r\n.vnsc-drawing-toolbar__btn--star-active {\r\n\tcolor: #f59e0b !important;\r\n\tbackground: rgba(245, 158, 11, 0.12) !important;\r\n}\r\n\r\n.vnsc-drawing-toolbar__btn--star-active:hover {\r\n\tbackground: rgba(245, 158, 11, 0.22) !important;\r\n}\r\n\r\n.vnsc-floating-favorites-bar {\r\n\tposition: fixed;\r\n\tz-index: var(--vnsc-z-popup, 20);\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tgap: 3px;\r\n\tbackground: var(--vnsc-bg-primary, #0a0e14);\r\n\tborder: 1px solid var(--vnsc-border, #2a2a2a);\r\n\tborder-radius: var(--vnsc-radius-md, 8px);\r\n\tpadding: 4px 6px;\r\n\tbox-shadow: 0 4px 20px rgba(0, 0, 0, 0.32);\r\n\tuser-select: none;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.vnsc-floating-favorites-grip {\r\n\tcursor: grab;\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\twidth: 14px;\r\n\theight: 28px;\r\n\tcolor: var(--vnsc-text-secondary, #a0a0a0);\r\n\topacity: 0.7;\r\n\ttransition: opacity var(--vnsc-transition-fast, 0.15s), color var(--vnsc-transition-fast, 0.15s);\r\n\tuser-select: none;\r\n\ttouch-action: none;\r\n\tfont-size: 12px;\r\n\tletter-spacing: 1px;\r\n}\r\n\r\n.vnsc-floating-favorites-grip:hover {\r\n\topacity: 1;\r\n\tcolor: var(--vnsc-text-primary, #ffffff);\r\n}\r\n\r\n.vnsc-floating-favorites-grip:active {\r\n\tcursor: grabbing;\r\n}\r\n\r\n.vnsc-floating-favorites-divider {\r\n\twidth: 1px;\r\n\theight: 18px;\r\n\tbackground: var(--vnsc-border-subtle, #2a2a2a);\r\n\tmargin: 0 3px;\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.vnsc-floating-favorites-close {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\twidth: 24px;\r\n\theight: 24px;\r\n\tborder: none;\r\n\tbackground: transparent;\r\n\tborder-radius: 4px;\r\n\tcolor: var(--vnsc-text-secondary, #a0a0a0);\r\n\tcursor: pointer;\r\n\ttransition: background var(--vnsc-transition-fast, 0.15s), color var(--vnsc-transition-fast, 0.15s);\r\n\tfont-size: 13px;\r\n\tline-height: 1;\r\n\tpadding: 0;\r\n}\r\n\r\n.vnsc-floating-favorites-close:hover {\r\n\tbackground: rgba(239, 68, 68, 0.15);\r\n\tcolor: #ef4444;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
